import { useEffect } from 'react'

/**
 * Close on Escape, ahead of everything else.
 *
 * Capture phase and stopped there: the cell editors and the notes drawer sit over a board
 * that may itself be inside a dialog (the month view's day dialog), and Modal.jsx listens for
 * Escape on the document. Without capture-and-stop, one keypress closed the popover AND the
 * dialog underneath it. Three components carried this same eight-line effect; this is the one
 * copy.
 *
 * `onEscape` is read through the closure on every keypress, so callers may pass an inline
 * arrow without the listener being torn down and re-added on every render.
 */
export function useEscapeKey(onEscape, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined
    const onKey = (e) => {
      if (e.key !== 'Escape') return
      e.preventDefault()
      e.stopPropagation()
      onEscape()
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [onEscape, enabled])
}
